//React Components 
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
//Images
import PCCcoin from "./img/PCCcoin.png"
import PCCcoin1 from "./img/PCCcoin1.png"
import PCCcoin10 from "./img/PCCcoin10.png"
import dollarOne from "./img/dollas-one.jpeg"
import dollarFive from "./img/dollas-five.jpeg"
import dollarTen from "./img/dollas-ten.jpeg"
import dollarTwenty from "./img/dollas-twenty.jpeg"
import dollarFifty from "./img/dollas-fifty.jpeg"
import dollarOneHundred from "./img/dollas-one-hundred.png"
import coin1 from "./img/coin1.png"
import coin5 from "./img/coin5.png"
import coin10 from "./img/coin10.png"
import coin25 from "./img/coin25.png"
import coin1b from "./img/coin1b.png"
import Modal from 'react-bootstrap/Modal';
import { RenderIf } from '../utils/RenderIf';
import ErrorAlert from '../Alerts/ErrorAlert';
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';
import './Cashierpost.css';

//Sweet alert
import Swal from "sweetalert2";

//api
import { MachinesFetchAPI } from '../../api/Machines';
import LoadingAlert from '../Alerts/LoadingAlert';

const Cashierpost = ({ setChange, setAmountOrder, setOrderNumber, setModalShow, order_data, statusCash, paymentInfo, mixto, setAmountPayment, amountPending, amountPayment, total }) => {
    let { business_code, branchoffice_code } = useParams();
    const [counter, setCounter] = useState(0)
    const [loader, setLoader] = useState(0)
    const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'))

    setAmountOrder(order_data.total.toFixed(2))
    //setOrderNumber(order_data.code)

    const checkAmount = () => {
        let total = (counter.toFixed(2) - (order_data.total.toFixed(2))).toFixed(2);
        if (total >= 0) {
            setLoader(1)
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Debe ingresar el monto a pagar o superior.',
                showConfirmButton: false,
                timer: 1500
            })
        }
    }

    const actionCounter = (value) => {
        let newAmount = (counter + value);
        if (mixto == true) {

            if (newAmount > amountPending) {
                setAmountPayment(amountPending)
                setAmountOrder(amountPending)
                ErrorAlert("", "El valor ingresado supera el valor pendiente", "warning")
            } else {
                setAmountPayment(newAmount)
                setAmountOrder(newAmount)
            }

        }
        setCounter((counter) => counter + value)
    }

    //Function to populate the card dollar
    const CardDollar = (props) => {
        return (
            <div className="sp-cash__cell" onClick={() => actionCounter(props.value)}>
                <div className="sp-cash__bill">
                    <img src={props.imgDollar} alt="" className='sp-cash__billimg' loading='lazy' />
                    <span className="sp-cash__billtag" translate='no'>${props.value}</span>
                </div>
            </div>
        )
    }



    //Function to populate the card coin 
    const CardCoin = (props) => {
        return (
            <>
                <div className="sp-cash__cell" onClick={() => actionCounter(props.value)}>
                    <div className="sp-cash__coin">
                        <img src={props.imgDollar} alt="" className='sp-cash__coinimg' />
                        <span className="sp-cash__billtag" translate='no'>${props.value}</span>
                    </div>
                </div>
            </>
        )
    }

    //save change cash
    const setChangeOrder = () => {
        let valorCambio = (counter.toFixed(2) - (order_data.total.toFixed(2))).toFixed(2)
        if (valorCambio >= 0) {

            setChange(valorCambio);
        }
    }

    //Consultar data inicial 
    const putOrderMachine = async (status, order) => {
        let boton = ""
        let text = ""
        let title = ""
        let respuestaAlert = ""
        let valorCambio = (counter.toFixed(2) - (order_data.total.toFixed(2))).toFixed(2)
        setBotonDeshabilitado(true);
        if (valorCambio >= 0 || status == 8) {
            if (status == 7) {
                title = "Aprobar Orden: " + order
                text = "Monto de la transaccion: " + order_data.total.toFixed(2) + ", Cambio: " + valorCambio
                boton = "Si, Aprobar pago"
                respuestaAlert = "Pago exitoso"
                setChange(valorCambio);
            }


            //Boton cancelar pago 
            else if (status == 8) {
                title = "Esta seguro que quiere cancelar la orden"
                text = "Orden: " + order
                boton = "Si, cancelar pago"
                respuestaAlert = "Pago cancelado con exito"
                setBotonDeshabilitado(true);
            }


            //Boton cancelar pago 
            Swal.fire({
                title: title,
                text: text,
                icon: 'warning',
                // showCancelButton: true,
                showDenyButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                // cancelButtonText: 'No ggggg',
                denyButtonText: ` No `,
                confirmButtonText: boton

            }).then((result) => {
                if (result.isConfirmed) {
                    peticion()
                    setBotonDeshabilitado(false);
                }
                else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    setBotonDeshabilitado(false);

                }

            })

        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Debe ingresar el monto a pagar o superior.',
                showConfirmButton: false,
                timer: 1500
            })

        }

        const peticion = async () => {
            let data = {
                "order_code": order,
                "business_code": business_code,
                "branchoffice_code": branchoffice_code,
                "state_id": status,
                "user_id": user.id
            }
            try {
                const response = await MachinesFetchAPI.updateStateOrder(data)
                console.log(response)
                statusCash(1)
                setChangeOrder()
            } catch (err) {
                /* Swal.fire({
                    icon: 'success',
                    title: respuestaAlert,
                    showConfirmButton: false,
                    timer: 1500
                }) */
                console.log(err)
            }
        }
    }

    const [keyed, setKeyed] = useState('');

    const keyPush = (d) => {
        if (d === '.' && keyed.includes('.')) return;
        if (keyed.includes('.') && keyed.split('.')[1]?.length >= 2) return;
        setKeyed((keyed === '0' && d !== '.') ? d : keyed + d);
    };
    const keyPush00 = () => { if (keyed === '' || keyed === '0') return; if (keyed.includes('.') && keyed.split('.')[1]?.length >= 1) return; setKeyed(keyed + '00'); };
    const keyBack = () => setKeyed(keyed.slice(0, -1));
    const keyAdd = () => { const v = Number(keyed || 0); if (v > 0) actionCounter(v); setKeyed(''); };

    const renderCahs = () => {
        const keyedDisplay = keyed === '' ? '0.00' : (keyed.includes('.') ? keyed : Number(keyed).toString());
        return (
            <>
                {/* Monto recibido (tu counter real) */}
                <div className="sp-cash__topbar">
                    <div className="sp-cash__received">
                        <span className="sp-cash__received-label"><i className="uil uil-arrow-to-bottom"></i> Monto recibido</span>
                        <span className="sp-cash__received-amount" translate="no">$ {counter.toFixed(2)}</span>
                    </div>
                    <button className="sp-cash__equal" onClick={() => setCounter(order_data.total)}>Monto igual</button>
                </div>

                {/* Billetes en fila */}
                <div className="sp-cash__denoms">
                    <span className="sp-cash__denlabel">Billetes </span>
                    <div className="sp-cash__denrow">
                        {paymentInfo.payment == "Efectivo" ? <>
                            <button className="sp-cash__chip" onClick={() => actionCounter(1)}>$1</button>
                            <button className="sp-cash__chip" onClick={() => actionCounter(5)}>$5</button>
                            <button className="sp-cash__chip" onClick={() => actionCounter(10)}>$10</button>
                            <button className="sp-cash__chip" onClick={() => actionCounter(20)}>$20</button>
                            <button className="sp-cash__chip" onClick={() => actionCounter(50)}>$50</button>
                            <button className="sp-cash__chip" onClick={() => actionCounter(100)}>$100</button>
                        </> : <>
                            <button className="sp-cash__chip" onClick={() => actionCounter(1)}>$1</button>
                            <button className="sp-cash__chip" onClick={() => actionCounter(5)}>$5</button>
                            <button className="sp-cash__chip" onClick={() => actionCounter(10)}>$10</button>
                        </>}
                    </div>
                </div>

                {/* Monedas en fila (solo efectivo) */}
                {paymentInfo.payment == "Efectivo" ? <>
                    <div className="sp-cash__denoms">
                        <span className="sp-cash__denlabel">Monedas</span>
                        <div className="sp-cash__denrow">
                            <button className="sp-cash__chip sp-cash__chip--coin" onClick={() => actionCounter(0.01)}>1¢</button>
                            <button className="sp-cash__chip sp-cash__chip--coin" onClick={() => actionCounter(0.05)}>5¢</button>
                            <button className="sp-cash__chip sp-cash__chip--coin" onClick={() => actionCounter(0.10)}>10¢</button>
                            <button className="sp-cash__chip sp-cash__chip--coin" onClick={() => actionCounter(0.25)}>25¢</button>
                            <button className="sp-cash__chip sp-cash__chip--coin" onClick={() => actionCounter(1.00)}>$1</button>
                        </div>
                    </div>
                </> : <></>}

                {/* Teclado numérico (estilo imagen) */}
                <div className="sp-cash__keypad d-none ">
                    <div className="sp-cash__display">
                        <span className="sp-cash__cur">$</span>
                        <span className="sp-cash__amount" translate="no">{keyedDisplay}</span>
                        <span className="sp-cash__caret" aria-hidden="true"></span>
                    </div>

                    <div className="sp-cash__pad">
                        {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map(n => (
                            <button key={n} type="button" className="sp-cash__key" onClick={() => keyPush(n)}>{n}</button>
                        ))}
                        <button type="button" className="sp-cash__key" onClick={keyPush00}>00</button>
                        <button type="button" className="sp-cash__key" onClick={() => keyPush('0')}>0</button>
                        <button type="button" className="sp-cash__key sp-cash__key--back" onClick={keyBack} aria-label="Borrar">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M21 4H8l-7 8 7 8h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z" /><line x1="18" y1="9" x2="12" y2="15" /><line x1="12" y1="9" x2="18" y2="15" /></svg>
                        </button>
                    </div>


                </div>

                {/* Acciones */}
                <div className="sp-cash__acts ">
                    {/* Agregar lo tecleado al monto recibido (usa tu actionCounter) agregar inmput directo en el monto y que salga el modal del teclado */}
                    <button type="button" className="sp-cash__addkeyed mb-2 d-none " onClick={keyAdd} disabled={!keyed || Number(keyed) <= 0}>
                        <i className="uil uil-plus"></i> Agregar ${keyed ? Number(keyed).toFixed(2) : '0.00'}
                    </button>
                    <div className='d-flex justify-content-between w-100'>
                        <div>
                            <button className="sp-cash__btn sp-cash__btn--danger" onClick={() => statusCash(2)}>Cancelar pago</button>
                            <button className="sp-cash__btn sp-cash__btn--ghost ms-2" onClick={() => setCounter(0)}>Borrar cuenta</button>
                        </div>


                        <button className="sp-cash__btn sp-cash__btn--ok" onClick={() => checkAmount() /*putOrderMachine(7, order_data.code)*/}>Continuar Pago</button>

                    </div>
                </div>
            </>
        )
    }
    const nextModal = () => {
        return (
            <>
                <div className="sp-cash__confirm">
                    <span className="sp-cash__confirm-title">Detalles de Transacción</span>
                    <div className="sp-cash__cards">
                        <div className="sp-cash__ccard is-blue">
                            <span className="sp-cash__ccard-label"><i className="uil uil-arrow-to-bottom"></i> Monto recibido</span>
                            <span className="sp-cash__ccard-amount" translate="no">$ {counter.toFixed(2)}</span>
                        </div>

                        <div className="sp-cash__ccard is-amber">
                            <span className="sp-cash__ccard-label"><i className="uil uil-top-arrow-from-top"></i> {mixto == true ? <>Saldo pendiente</> : <>Monto a devolver</>}</span>
                            <span className="sp-cash__ccard-amount" translate="no"> ${mixto == true ? <>{(amountPending - counter).toFixed(2)}</> : <> {(counter.toFixed(2) - (order_data.total.toFixed(2))).toFixed(2)}</>} </span>
                        </div>

                        {mixto !== true ? <>
                            <div className="sp-cash__ccard is-green">
                                <span className="sp-cash__ccard-label"><i className="uil uil-usd-circle"></i> Monto a pagar</span>
                                <span className="sp-cash__ccard-amount" translate="no">${order_data.total.toFixed(2)}</span>
                            </div>
                        </> : <></>}
                    </div>
                </div>

                <div className="sp-cash__acts sp-cash__acts--end">
                    <button className="sp-cash__btn sp-cash__btn--danger" onClick={() => statusCash(2)}>Cancelar pago</button>
                    <button className="sp-cash__btn sp-cash__btn--primary" disabled={botonDeshabilitado} onClick={() => (statusCash(1), setChangeOrder())}>Finalizar pago</button>
                </div>
            </>
        )
    }



    return (
        <>

            <RenderIf isTrue={loader == 0}>
                {renderCahs()}
            </RenderIf>
            <RenderIf isTrue={loader == 1}>
                {nextModal()}
            </RenderIf>





        </>


    )
}

export default Cashierpost